import { valueStoreFactory } from 'services/utils/valueStoreFactory';

export const wizardStepIdValueStore = valueStoreFactory();
